import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { createAction } from 'redux-actions'

import itemInteractions from './itemInteractions'
import player from './player'
import gameProgress from './gameProgress'
import quizzes from './quizzes'

/***
 * Common Actions
 *
 * The following actions are globally recognized by one or more subreducers.
 */
export const RESET_GAME = 'BPF_4075/RESET_GAME'
export const resetGame = createAction(RESET_GAME)

const rootPersistConfig = {
  key: 'root',
  storage,
  blacklist: ['gameProgress', 'player', 'quizzes'],
}

const gameProgressPersistConfig = {
  key: 'gameProgress',
  storage,
  blacklist: ['modalIsActive'],
}

const playerPersistConfig = {
  key: 'player',
  storage,
  blacklist: [],
}

const quizzesPersistConfig = {
  key: 'quizzes',
  storage,
  blacklist: ['isActive', 'question', 'answer', 'options'],
}

const rootReducer = combineReducers({
  itemInteractions,
  player: persistReducer(playerPersistConfig, player),
  gameProgress: persistReducer(gameProgressPersistConfig, gameProgress),
  quizzes: persistReducer(quizzesPersistConfig, quizzes),
  router: routerReducer,
})

export default persistReducer(rootPersistConfig, rootReducer)



// WEBPACK FOOTER //
// ./src/modules/index.js